import { Bullseye, Spinner } from "@patternfly/react-core";

export const KeycloakSpinner = () => (
  <Bullseye>
    <Spinner />
  </Bullseye>
);
